import { createContext } from 'react';
import type { CarouselAPI } from './types';

export const CarouselAPIContext = createContext<CarouselAPI | undefined>(
  undefined
);
